import { FETCH_DOWNLOAD_LIST, FETCH_LIST, FETCH_TAB_AND_FILTER } from "./actionTypes";
import { tableListTypes } from "../../../utils/utility";
import { MODULE_NAME } from "./constants";

import { apiReducer } from "../../../utils/reduxUtil";


const initialState = {
  [tableListTypes.SERVICE_REQUEST]: {},
  [tableListTypes.BANK_STATEMENTS]: {},
  [tableListTypes.CUSTOMER_SERVICE_REQUESTS]: {},
};

const fetchTabAndFilterSuccess = (state, action) => {
  const { listType } = action;
  const { fetchTabAndFilter, ...restState } = state[listType];

  return {
    ...state,
    [listType]: {
      ...restState,
      tabList: fetchTabAndFilter.tabs,
    },
  };
};

const fetchListSuccess = (state, action) => {
  const { listType, isOnHold } = action;
  const { fetchList, ...restState } = state[listType];
  const { list, BANK_STATEMENT, totalCount, holdReasons = null, bounceVerification = null, employmentVerification = null, eVehicleVerification = null } = fetchList;
  return {
    ...state,
    [listType]: {
      ...restState,
      isOnHold: isOnHold,
      fetchList: BANK_STATEMENT ? BANK_STATEMENT : list, // Temparory fix for table list data
      totalCount: totalCount,
      holdReasons: holdReasons,
      employmentVerification: employmentVerification,
      bounceVerification: bounceVerification,
      eVehicleVerification: eVehicleVerification,
    },
  };
};

const fetchDownloadListSuccess = (state, action) => {
  const { listType, selectedHeaders, downloadFileName } = action;
  const { fetchDownloadList, ...restState } = state[listType];

  const { list } = fetchDownloadList;

  return {
    ...state,
    [listType]: {
      ...restState,
      fetchDownloadList: list,
      selectedHeaders: selectedHeaders,
      downloadFileName: downloadFileName,
    },
  };
};

const tableReducer = (state = initialState, action) => {
  if (!action.listType) {
    return state;
  }

  let newState = state[action.listType] ? state : { ...state, [action.listType]: {} };
  const apiReducerUpdatedState = apiReducer(newState[action.listType], action, MODULE_NAME);

  if (apiReducerUpdatedState !== newState[action.listType]) {
    newState = { ...state, [action.listType]: apiReducerUpdatedState };
  }

  switch (action.type) {
    case `${FETCH_TAB_AND_FILTER}_SUCCESS`:
      return fetchTabAndFilterSuccess(newState, action);

    case `${FETCH_LIST}_SUCCESS`:
      return fetchListSuccess(newState, action);

    case `${FETCH_DOWNLOAD_LIST}_SUCCESS`:
      return fetchDownloadListSuccess(newState, action);

    default:
      return newState;
  }
};

export default tableReducer;
